/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GlobalCSS from '../styles/';
import ScrollMagic from 'scrollmagic';
import { TimelineMax } from 'gsap/all';
import { graphql, StaticQuery } from 'gatsby';
import Header from './header';
import Loading from './loading';
import CustomCursor from './custom-cursor';
import SetVhUnitsOnTouchDevices from './set-vh-units-on-touch-devices';
import { colors } from '../styles/vars';
import * as helpers from '../helpers';
import BackToTop from './back-to-top';
import SEO from './seo';

require('animation.gsap');
require('debug.addIndicators');

export default class Layout extends Component {
  constructor() {
    super();
    this.state = {
      ready: false,
    };

    this.getScrollAnimationsOffset();
  }

  componentDidMount() {
    this.controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 'onEnter',
      },
    });

    this.animationElement = document.querySelectorAll('[data-anim-in]');
    this.scrollItemsUp(this.animationElement);

    if (process.env.NODE_ENV !== 'development') {
      console.log(
        '%c Oh hai, I’m glad you came to peep under the hood. This site was built using GatsbyJS, Styled Components, GSAP, and ScrollMagic — the stack is a little outdated at this point, but it’s still working great. I’m particularly proud of the over-the-top level of detail I put into the testimonials carousel animations. The little circle indicator around the numbers not only completes the circle when you first scroll down the page, but it also animates in the correct direction when you navigate between testimonials. I consider this level of attention to detail my calling card: not always noticed, but always felt.',
        'background-color: ' +
          colors.brand +
          '; color: #ffffff; padding: 10px; line-height: 30px; font-size: 14px'
      );
    }
  }

  getScrollAnimationsOffset = () => {
    this.scrollAnimationsOffset = helpers.breakpoints.lg() ? 200 : 80;
  };

  handleLoader = () => {
    this.setState({ ready: true });
  };

  handleIntroReady = () => {
    document.dispatchEvent(new Event('portfolio:intro-ready'));
  };

  animateItemsUp = element => {
    [...element].forEach(item => {
      new ScrollMagic.Scene({
        triggerElement: item,
      })
        .setClassToggle(item, 'has-animated')
        .offset(150)
        .reverse(false)
        .addTo(this.controller);
    });
  };

  scrollItemsUp = element => {
    [...element].forEach(item => {
      let genericAppearAnimation = new TimelineMax().fromTo(
        item,
        1,
        {
          y: 30,
          opacity: 0,
          scale: 0.98,
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
        }
      );

      new ScrollMagic.Scene({
        duration: 200,
        triggerElement: item,
      })
        .offset(this.scrollAnimationsOffset)
        .setTween(genericAppearAnimation)
        // .addIndicators({ name: item.getAttribute('class') })
        // .on('progress', function(event) {
        //   tl.seek(tl.duration * event.progress);
        // })
        .addTo(this.controller);
    });
  };

  render() {
    return (
      <>
        <StaticQuery
          query={graphql`
            query SiteTitleQuery {
              site {
                siteMetadata {
                  title
                }
              }
            }
          `}
          render={data => (
            <Container id="top">
              <Header siteTitle={data.site.siteMetadata.title} />
              <div>
                <Main>{this.props.children}</Main>
              </div>
              <aside>
                <BackToTop />
              </aside>
              <GlobalCSS />
              <CustomCursor />
              <SetVhUnitsOnTouchDevices />
            </Container>
          )}
        ></StaticQuery>
        {!this.state.ready && (
          <Loading
            handleLoader={this.handleLoader}
            handleIntroReady={this.handleIntroReady}
          />
        )}
        <SEO
          canonical={this.props.canonical}
          title="Freelance Front-end Developer based in Melbourne - Mike Barker"
        />
      </>
    );
  }
}

const Main = styled.main``;

const Container = styled.div`
  overflow: hidden;
  min-height: 100%;
`;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
